import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretUp } from '@fortawesome/pro-solid-svg-icons/faCaretUp';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import { faDash } from '@fortawesome/pro-light-svg-icons/faDash';
import { TypedMemo } from '../../../common/types';

interface PositionChangeElementProps {
  previousPosition?: number | null;
  currentPosition?: number;
}

const PositionChangeElementComponent: React.FC<PositionChangeElementProps> = ({
  previousPosition,
  currentPosition,
}) => {
  const getPositionChangeInfo = () => {
    if (previousPosition === null || previousPosition === undefined || currentPosition === undefined) {
      return {
        icon: faDash,
        className: 'change-neutral',
        change: 0,
      };
    }

    // Lower position number means better rank (position 1 is better than position 2)
    if (currentPosition < previousPosition) {
      return {
        icon: faCaretUp,
        className: 'change-positive',
        change: Math.abs(currentPosition - previousPosition),
      };
    }

    if (currentPosition > previousPosition) {
      return {
        icon: faCaretDown,
        className: 'change-negative',
        change: Math.abs(currentPosition - previousPosition),
      };
    }

    return {
      icon: faDash,
      className: 'change-neutral',
      change: 0,
    };
  };

  const changeInfo = getPositionChangeInfo();

  return (
    <div
      className={`${changeInfo.className} d-flex align-items-center justify-content-center rounded px-2 py-1 gap-1 font-monospace`}
      style={{ minWidth: 36 }}
    >
      <FontAwesomeIcon icon={changeInfo.icon} size="sm" />
      {changeInfo.change !== 0 && <span>{changeInfo.change.toLocaleString()}</span>}
    </div>
  );
};

export const PositionChangeElement = TypedMemo(PositionChangeElementComponent);
